import { CSSProperties, useMantineTheme } from '@mantine/core';

import { SVGIconProps } from '../types';
import styles from './AddIcon.module.scss';

interface Props extends SVGIconProps {
  isDisabled?: boolean;
  variant?: 'primary' | 'secondary' | 'dark';
  style?: CSSProperties;
  circleStrokeWidth?: number;
}

export const AddIcon = ({
  style,
  isDisabled = false,
  variant = 'primary',
  circleStrokeWidth = 2,
  ...props
}: Props) => {
  const theme = useMantineTheme();

  return (
    <svg
      data-disabled={isDisabled}
      data-variant={variant}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="add icon"
      style={style}
      className={styles.addIcon}
      {...props}
    >
      <circle
        cx="12"
        cy="12"
        r="11"
        fill={theme.colors.zorroIris[9]}
        stroke={theme.colors.zorroIris[9]}
        strokeWidth={circleStrokeWidth}
      />
      <mask
        id="mask0_343_1537"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="4"
        y="4"
        width="16"
        height="16"
      >
        <rect
          x="5.30005"
          y="5.3"
          width="13.4"
          height="13.4"
          fill={theme.colors.zorroGray[3]}
          stroke={theme.colors.zorroIris[9]}
        />
      </mask>
      <g mask="url(#mask0_343_1537)">
        <path
          d="M12.0001 6.90883V17.0912"
          stroke={theme.colors.zorroWhite[0]}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.90894 12H17.0913"
          stroke={theme.colors.zorroWhite[0]}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};
